import React from 'react';

import { mqMin, LucidTheme } from '@lucid/theme';

import Box from '../../box/box';
import Text from '../../text/text';
import Link from '../../link/link';

export interface QuoteCtaLinkType {
  /** Data about the CTA */
  fieldCta?: {
    /** Text in CTA */
    title?: string;
    /** URL of CTA */
    url?: {
      path?: string;
    }
  };
  /** Determines whether or not the CTA will have an arrow */
  fieldLinkHasArrow?: boolean;
}

export interface QuoteCarouselItemType{
  /** String containing the full attribution */
  fieldAttribution?: string;
  /** Quote text */
  fieldQuote?: string;
  /** Data for the quote item's CTA */
  fieldQuoteCtaLink?: QuoteCtaLinkType
}

const QuoteCarouselItem = ({
  fieldAttribution,
  fieldQuote,
  fieldQuoteCtaLink
}: QuoteCarouselItemType) => {
  const quoteLink = fieldQuoteCtaLink as QuoteCtaLinkType;
  const attribution = fieldAttribution;
  const linkPath = quoteLink?.fieldCta?.url?.path;
  const linkText = quoteLink?.fieldCta?.title;
  const quoteText = fieldQuote;

  return (
    <Box
      css={{
        flex: '0 0 100%'
      }}
    >
      <Box
        css={(theme: LucidTheme) => ({
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          maxWidth: '780px',
          margin: 'auto',
          padding: `0 ${theme.space.s48}px`,
          [mqMin.tablet]: {
            padding: `0 ${theme.space.s24}px`
          }
        })}
      >
        <Text variant="paragraphXL300">
          {quoteText}
        </Text>
        <Text
          css={(theme: LucidTheme) => ({
            fontWeight: theme.fontWeights.strong
          })}
          variant="paragraphM400"
        >
          {attribution}
        </Text>
        <Link
          hasArrow
          to={linkPath}
        >
          {linkText}
        </Link>
      </Box>
    </Box>
  );
};

export default QuoteCarouselItem;
